const items = [
    "Cargas fracionadas",
    "Lotação dedicada",
    "Armazenagem",
    "Distribuição última milha",
    "Cobertura nacional",
];

const Track = ({ hidden }) => (
    <div aria-hidden={hidden || undefined} className="flex w-max items-center">
        {items.map((item) => (
            <span key={item} className="flex items-center">
                <span className="whitespace-nowrap px-6 font-display text-2xl font-bold uppercase italic tracking-wide text-ink md:px-10 md:text-4xl">
                    {item}
                </span>
                <span className="checkers inline-block h-4 w-4 shrink-0 opacity-80" />
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <div
        data-testid="marquee-ticker-container"
        className="relative z-10 -rotate-1 scale-[1.02] overflow-hidden border-y-2 border-ink bg-magenta py-4 shadow-[0_10px_50px_rgba(176,38,214,0.35)] md:py-5"
    >
        <div className="animate-marquee flex w-max">
            <Track />
            <Track hidden />
        </div>
    </div>
);
